import './App.css';
import Layout from './Components/Layout';
import CookieConsent from './Components/CookieConsent';

function App() {
  return (
    <div className="App">
      <CookieConsent onPreferencesChange={(prefs) => console.log(prefs)} />
      <Layout />
    </div>
  );
}

export default App;